import { Button, HStack, Stack } from '@chakra-ui/react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuthorization } from '$/components/core/Authentication/hooks/useAuthorization';
import { FacetDropdown } from '$/pages/DashboardPages/pages/DesignGuide/components/FacetDropdown';
import { HarmonyFilterTags } from '$/pages/DashboardPages/pages/DesignGuide/components/HarmonyFilterTags';
import { HarmonyViewOptionSelector } from '$/pages/DashboardPages/pages/DesignGuide/components/HarmonyViewOptionSelector';
import {
  useDesignGuideStore,
  type HarmonyFacet,
} from '$/pages/DashboardPages/pages/DesignGuide/stores/useDesignGuideStore';

export const HarmonyFilters: FC = () => {
  const { t } = useTranslation();
  const { hasPermission } = useAuthorization();
  const selection = useDesignGuideStore.useSelection();
  const reset = useDesignGuideStore.useReset();
  const viewMode = useDesignGuideStore.useViewMode();

  const hasActiveFilter = Object.keys(selection).some(
    (key) => key !== 'scene' && !!selection[key as HarmonyFacet],
  );

  const isDisabled = !hasPermission('DesignGuide_Open');

  return (
    <Stack gap='3' w='full'>
      <HStack align='flex-start' justify='space-between' gap='4' w='full'>
        <HStack
          className='hidden-scrollbar'
          flex='1'
          gap='4'
          overflowX='auto'
          minW='0'
          py='2'
        >
          <FacetDropdown
            facet={'mood'}
            label={t('dashboard.designGuide.mood')}
            isDisabled={isDisabled}
          />
          <FacetDropdown
            facet={'tonality'}
            label={t('dashboard.designGuide.tonality')}
            isDisabled={isDisabled}
          />
          <FacetDropdown
            facet={'colorRange'}
            label={t('dashboard.designGuide.colorRange')}
            isDisabled={isDisabled}
          />
          {viewMode === 'scene' && (
            <FacetDropdown
              facet={'sceneType'}
              label={t('dashboard.designGuide.sceneType')}
              isDisabled={isDisabled}
            />
          )}
        </HStack>
        <HarmonyViewOptionSelector isDisabled={isDisabled} />
      </HStack>

      {hasActiveFilter && (
        <HStack justify='space-between' gap='6' w='full' fontSize='sm'>
          <HarmonyFilterTags />
          <Button
            flexShrink='0'
            px='0'
            color='lighterText'
            fontSize='sm'
            onClick={() => reset()}
            variant='text'
          >
            {t('dashboard.collection.resetFilter')}
          </Button>
        </HStack>
      )}
    </Stack>
  );
};
